import { API } from "@/services"

export const FILTERS_ENDPOINTS = {
  create(data={}){
    return API.Axios.error_capture.v1.request({
      url: `filters`,
      method: 'POST',
      data,
    })
  },
  delete(id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `filters/${id}`,
      method: 'DELETE',
      data,
    })
  },
  list(type='',params={}){
    return API.Axios.error_capture.v1.request({
      url: `filters/${type}`,
      method: 'GET',
      params,
    })
  },
}